// extracted by mini-css-extract-plugin
export default {"loading_container":"loading_loading_container__Ne9UR","loading_card":"loading_loading_card__e9SZy"};